import React, { useEffect, useCallback, useMemo } from "react";
import _ from "lodash";

const CustomSubmit = React.memo(({ data1, data2, handleSubmit, onRefreshPage }) => {
  // Memoize the comparison result to prevent recalculations
  const hasChanges = useMemo(() => !_.isEqual(data1, data2), [data1, data2]);

  // Memoize the click handler to avoid re-creating the function
  const handleSave = useCallback(async () => {
    try { 
      await handleSubmit();
      // Refresh component for mobile safety guides page after successful publish
      if (window.location.pathname === '/shore/webpages/legal/mobile-safety-and-guides' && onRefreshPage) {
        onRefreshPage();
      }
    } catch (error) {
      console.error('Publish failed:', error);
    }
  }, [handleSubmit, onRefreshPage]);

  return (
    <div className="text-right" style={{ marginBottom: "10px" }}>

      <button onClick={handleSave} className="btn main_submit" style={{ background: "green" }}>
        Publish
      </button>

    </div>
  );
});

export default CustomSubmit;
